export default "__VITE_ASSET__CvsjkAPA__"